module.exports = __webpack_public_path__ + "static/img/hbczzx.978cc90.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/hbczzx.png
// module id = nnKa
// module chunks = 0